





window.typeOf = function(o, t) {
	if (o !== o) return 'NaN';
	let typeStr = Object.prototype.toString.call(o);
	return typeStr.substring(8, typeStr.length - 1);
}



window.UUID = {
	cs: '012346789abcdef'.toUpperCase().split(''),
	get: function(n) {
		n = n || 32;
		var value = "";
		for (var i = 0; i < n; i++) {
			var index = Math.floor(Math.random() * this.cs.length);
			value += this.cs[index];
		}
		return value;
	}
};
if (!localStorage.getItem('uuid')) {
	localStorage.setItem('uuid', UUID.get());
}

Date.prototype.format = function(fmt) {
	if (!fmt) fmt = "yyyy-MM-dd hh:mm:ss";
	let o = {
		"M+": this.getMonth() + 1, //月份
		"W": (function(date) {
			switch (date.getDay()) {
				case 0:
					return "日";
				case 1:
					return "一";
				case 2:
					return "二";
				case 3:
					return "三";
				case 4:
					return "四";
				case 5:
					return "五";
				case 6:
					return "六";
				default:
					return "";
			}
		})(this), //星期
		"d+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S": this.getMilliseconds() //毫秒
	};
	if (/(y+)/.test(fmt))
		fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (let k in o)
		if (new RegExp("(" + k + ")").test(fmt))
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
				.length)));
	return fmt;
};

Date.create = function(year, month, day, hour, minute, second) {
	const date = new Date();
	if (typeOf(year) == 'Number') {
		date.setFullYear(year);
	}
	if (typeOf(month) == 'Number') {
		date.setMonth(month - 1);
	}
	if (typeOf(day) == 'Number') {
		date.setDate(day);
	}
	if (typeOf(hour) == 'Number') {
		date.setHours(hour);
	}
	if (typeOf(minute) == 'Number') {
		date.setMinutes(minute);
	}
	if (typeOf(second) == 'Number') {
		date.setSeconds(second);
	}
	return date;
}

Date.parseDate = function(value) {
	if (!value) return null;
	if (typeOf(value) == 'Date') return value;
	if (typeOf(value) == 'Number') {
		value = value + '';
	}
	if (typeOf(value) == 'String') {
		if (/^\d{4}-\d{1,2}-\d{1,2} \d{1,2}:\d{1,2}:\d{1,2}$/.test(value)) {
			let splits = value.split(/[- :]+/);
			return Date.create(splits[0], splits[1], splits[2], splits[3], splits[4], splits[5]);
		}
		if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(value)) {
			let splits = value.split(/[- :]+/);
			return Date.create(splits[0], splits[1], splits[2]);
		}
		if (/^\d{8}$/.test(value)) {
			return Date.create(value.substr(0, 4), value.substr(4, 2), value.substr(6, 2));
		}
		if (/^\d{13}$/.test(value)) {
			return new Date(value * 1);
		}
		if (/^\d{10}$/.test(value)) {
			return new Date(value * 1000);
		}
	}
};




window.getParameterByQueryString = function(queryString, key) {
	let reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`, "i");
	let r = queryString.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
}


window.getParameter = function(key) {
	return getParameterByQueryString(location.search, key);
}



window.parseJson = function(o) {
	if (typeOf(o) == 'Object') {
		return o;
	} else if (typeOf(o) == 'String' && (o.startsWith('[') || o.startsWith('{'))) {
		return JSON.parse(o);
	}
	return null;
}

window.parseJsonObject = function(o) {
	if (typeOf(o) == 'Object') {
		return o;
	} else if (typeOf(o) == 'String' && o.startsWith('{')) {
		return JSON.parse(o);
	}
	return null;
}

window.parseJsonArray = function(o) {
	if (typeOf(o) == 'Object') {
		return o;
	} else if (typeOf(o) == 'String' && o.startsWith('[')) {
		return JSON.parse(o);
	}
	return null;
}

window.parseJsonString = function(o) {
	if (typeOf(o) == 'Object') {
		return JSON.stringify(o);
	} else if (typeOf(o) == 'String' && (o.startsWith('[') || o.startsWith('{'))) {
		return o;
	}
	return null;
}

window.queryString = function(json) {
	return Object.keys(json).map(function(key) {
		return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`;
	}).join("&");
}


window.setCookie = function(cname, cvalue, exdays) {
	exdays = exdays || 1;
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toGMTString();
	document.cookie = cname + "=" + cvalue + "; " + expires;
}

window.getCookie = function(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i].trim();
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}



window.Message = {
	tag: 'div',
	id: 'message',
	htmlToElement(html) {
		var div = document.createElement("div");
		div.innerHTML = html;
		return div.childNodes[0];
	},
	themeToColor(theme) {
		switch (theme) {
			case 'success':
				return '#67C23A';
			case 'warning':
				return '#E6A23C';
			case 'error':
				return '#F56C6C';
			case 'debug':
				return '#409EFF';
			default:
				return '#909399';
		}
	},
	close() {
		let e = document.getElementById(this.id);
		if (e != null) e.remove();
		clearTimeout(this.timeout);
	},
	msg(text, time, theme) {
		this.close();
		const html =
			`<div id="${this.id}" style="position:fixed;display:block;z-index:9999;top:50%;left:50%;transform:translate(-50%,-50%);font-size:14px;line-height:2;max-width:80%;padding:0 .75em;border-radius:.25em;opacity:.75;color:white;text-align:center;background-color:${this.themeToColor(theme)};">${text}</div>`;
		document.body.appendChild(this.htmlToElement(html));
		this.timeout = setTimeout(this.close.bind(this), time || 2000);
	},

	success(text, time) {
		this.msg(text || '操作成功！', time, 'success');
	},
	warning(text, time) {
		this.msg(text || '操作失败！', time || 3000, 'warning');
	},
	error(text, time) {
		this.msg(text || '操作失败！', time || 3000, 'error');
	},
	debug(text, time) {
		this.msg(text, time || 3000, 'debug');
	},
};



window.Loading = {
	id: 'loading',
	source: `data:image/png;base64,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`,
	htmlToElement(html) {
		var div = document.createElement("div");
		div.innerHTML = html;
		return div.childNodes[0];
	},
	close() {
		let e = document.getElementById(this.id);
		if (e != null) e.remove();
		clearTimeout(this.timeout);
	},
	open(time) {
		this.close();
		const html = `<div id="${this.id}" style="position:fixed;display:block;z-index:9999;top:0;bottom:0;left:0;right:0;background-color:rgba(255,255,255,.5)">
            <img style="position:absolute;width:5em;height:5em;top:50%;left:50%;animation:loading 3s linear infinite;" src="${this.source}"/>
            </div>`;
		document.body.appendChild(this.htmlToElement(html));
		this.timeout = setTimeout(this.close.bind(this), time || 30000);
	},
};